import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5001 6C7.5001 4.80653 7.9742 3.66193 8.81812 2.81802C9.66203 1.97411 10.8066 1.5 12.0001 1.5C13.1936 1.5 14.3382 1.97411 15.1821 2.81802C16.026 3.66193 16.5001 4.80653 16.5001 6C16.5001 7.19347 16.026 8.33807 15.1821 9.18198C14.3382 10.0259 13.1936 10.5 12.0001 10.5C10.8066 10.5 9.66203 10.0259 8.81812 9.18198C7.9742 8.33807 7.5001 7.19347 7.5001 6ZM3.7511 20.105C3.78482 17.9395 4.66874 15.8741 6.21206 14.3546C7.75538 12.8351 9.83431 11.9834 12.0001 11.9834C14.1659 11.9834 16.2448 12.8351 17.7881 14.3546C19.3315 15.8741 20.2154 17.9395 20.2491 20.105C20.2517 20.2508 20.2117 20.3942 20.1341 20.5176C20.0565 20.641 19.9446 20.7392 19.8121 20.8C17.3613 21.9237 14.6963 22.5037 12.0001 22.5C9.2141 22.5 6.5671 21.892 4.1881 20.8C4.05558 20.7392 3.94367 20.641 3.86606 20.5176C3.78844 20.3942 3.74849 20.2508 3.7511 20.105Z"
        fill={colorValue}
      />
    </svg>
  );
};
